import { Fragment, memo } from "react";

import Grid2, { Grid2Props } from "@mui/material/Unstable_Grid2";

// -----------------------------------------------------------------------------

/** <dl> using Grid2 */
const DefinitionList = memo(function DefinitionList({
  dtProps,
  ddProps,
  items,
}: DefinitionListProps) {
  const nodes = items.map((item) => (
    <Fragment key={item.key ?? item.dt?.toString()}>
      <Grid2 {...dtProps}>{item.dt}</Grid2>
      <Grid2 {...ddProps}>{item.dd}</Grid2>
    </Fragment>
  ));
  return (
    <Grid2 container component="dl">
      {nodes}
    </Grid2>
  );
});

export default DefinitionList;

interface DefinitionListProps {
  dtProps?: Grid2Props;
  ddProps?: Grid2Props;
  items: Array<{ key?: string; dt: React.ReactNode; dd: React.ReactNode }>;
}
